"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridCoreVirtualizedList = void 0;
const react_1 = __importStar(require("react"));
const react_window_1 = require("react-window");
const GridCoreEmptyRow_1 = require("./components/GridCoreEmptyRow");
const GridCoreRow_1 = require("./components/GridCoreRow");
const constants_1 = require("./helpers/constants");
const helpers_1 = require("../../../helpers");
exports.GridCoreVirtualizedList = (0, react_1.memo)(function GridCoreVirtualizedList({ apiRef, wrapperRef, rowRenderer, rowWidth, rowHeight, itemCount, itemKey, onScroll, onItemsRendered, onHeightChange }) {
    const wrapperSize = (0, helpers_1.useResizeObserver)(wrapperRef);
    const hasItems = (0, react_1.useMemo)(() => itemCount > 0, [itemCount]);
    const listHeight = (0, react_1.useMemo)(() => { var _a; return (_a = wrapperSize.height) !== null && _a !== void 0 ? _a : 0; }, [wrapperSize.height]);
    (0, react_1.useEffect)(() => {
        onHeightChange === null || onHeightChange === void 0 ? void 0 : onHeightChange(listHeight);
    }, [listHeight, onHeightChange]);
    (0, react_1.useEffect)(() => {
        const rootElement = wrapperRef.current;
        if (rootElement) {
            const scrollLeft = rootElement.scrollLeft;
            onScroll === null || onScroll === void 0 ? void 0 : onScroll({
                scrollLeft: scrollLeft,
                isXScroll: Boolean(scrollLeft)
            });
            const onListScroll = () => {
                const scrollLeft = rootElement.scrollLeft;
                onScroll === null || onScroll === void 0 ? void 0 : onScroll({
                    scrollLeft: scrollLeft,
                    isXScroll: Boolean(scrollLeft)
                });
            };
            rootElement.addEventListener('scroll', onListScroll);
            return () => {
                rootElement.removeEventListener('scroll', onListScroll);
            };
        }
        return;
    }, [onScroll, wrapperRef]);
    const renderer = (0, react_1.useCallback)(rowRenderer, [rowRenderer]);
    const itemData = (0, react_1.useMemo)(() => {
        return {
            renderer,
            rowWidth
        };
    }, [renderer, rowWidth]);
    const listStyle = (0, react_1.useMemo)(() => {
        return {
            flexGrow: 1
        };
    }, []);
    const handleOnItemsRendered = (0, react_1.useCallback)((props) => {
        if (hasItems) {
            onItemsRendered === null || onItemsRendered === void 0 ? void 0 : onItemsRendered(props);
        }
    }, [hasItems, onItemsRendered]);
    const listItemCount = (0, react_1.useMemo)(() => (hasItems ? itemCount : 1), [hasItems, itemCount]);
    return (react_1.default.createElement(react_window_1.FixedSizeList, { ref: apiRef, outerRef: wrapperRef, height: listHeight, itemData: itemData, itemSize: rowHeight, itemCount: listItemCount, itemKey: itemKey, width: "100%", overscanCount: constants_1.overscanCount, style: listStyle, onItemsRendered: handleOnItemsRendered }, hasItems ? GridCoreRow_1.GridCoreRow : GridCoreEmptyRow_1.GridCoreEmptyRow));
});
//# sourceMappingURL=GridCoreVirtualizedList.js.map